<template>
    <v-card flat>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 sm6 md4>
    <barchart
      :chartdata="locationunitsummary"
      :options="locationunitsummarychartoptions"></barchart>
      </v-flex>
      <v-flex xs12 sm6 md4>
    <piechart
      :chartdata="takeuppercentage"></piechart>
      </v-flex>
      <v-flex xs12 sm6 md4>
      
          <v-container fluid text-xs-center pt-5 width="100%">
              <v-layout align-center justify-center row fill-height>
                  <v-card flat color="white">
                  <v-flex xs12 sm12 md12>
          <v-flex xs12 sm12 md12 my-5>
              <h3><v-icon>home</v-icon> Units Passed: {{locationnetworksummarypage.count}}</h3>
          </v-flex>
          <v-flex xs12 sm12 md12 my-5>
              <h3><v-icon>share</v-icon> Passive Installs Complete: {{passiveinstallscompleted}}</h3>
          </v-flex>
          <v-flex xs12 sm12 md12 my-5>
              <h3><v-icon>share</v-icon> Active Installs Complete: {{activeinstallscompleted}}</h3>
          </v-flex>
          <v-flex xs12 sm12 md12 my-5>
              <h3><v-icon>devices_other</v-icon> Live Connections: {{activeserviceaccounts}}</h3>
          </v-flex>
          </v-flex>
          </v-card>
          </v-layout>
          </v-container>
          </v-flex>
                
                </v-layout>
                  </v-container>
                  </v-card>
</template>
<script>
import Api from "@/services/Api";
import BarChart from '@/components/BarChart.vue';
import PieChart from '@/components/PieChart.vue';
import LineChart from '@/components/LineChart.vue';
import DoughnutChart from '@/components/DoughnutChart.vue';
import dateformat from "dateformat";

export default {
    props: ['locationnetworksummarypage','locationunitsummary','locationunitsummarychartoptions','takeuppercentage','activeserviceaccounts','passiveinstallscompleted','activeinstallscompleted'],
    components: { 
    barchart: BarChart,
  piechart: PieChart,
  linechart: LineChart,
  doughnutchart: DoughnutChart },
    data (){
      return {
        loaded: false,

      }
    },
    
    
}
</script>
